import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import {
  Email,
  Phone,
  LocationOn,
  Facebook,
  Twitter,
  LinkedIn,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import SeoInfo from "../../SeoInfo";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let errors = {};
    if (!formData.firstName) errors.firstName = "First name is required";
    if (!formData.lastName) errors.lastName = "Last name is required";
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!formData.message) errors.message = "Message is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Handle form submission
      console.log("Form submitted", formData);
    }
  };

  return (
    <>
      <SeoInfo
        title="Car Mechanic Online – Instant Booking contact us Go clutch "
        description="Need a car mechanic online? Go Clutch connects you to skilled professionals for quick fixes, maintenance & emergency car care. Fast, reliable & easy!"
      />
      <Box sx={{ padding: { xs: 2, md: 4 }, backgroundColor: "#f9f9f9" }}>
        {/* Header Section */}

        <Box sx={{ textAlign: "center", marginBottom: 4 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#333",
              fontSize: { xs: "2rem", md: "3rem" },
            }}
          >
            Contact Us
          </Typography>
          <Typography variant="subtitle1" sx={{ color: "#555" }}>
            We'd love to hear from you! Please fill out the form below.
          </Typography>
        </Box>

        {/* Contact Form and Information */}
        <Grid container spacing={4}>
          {/* Contact Form Section */}
          <Grid item xs={12} md={6}>
            <Card sx={{ boxShadow: 4, borderRadius: 2 }}>
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{ marginBottom: 2, color: "#333" }}
                >
                  Get in Touch
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="First Name"
                        name="firstName"
                        fullWidth
                        margin="normal"
                        required
                        value={formData.firstName}
                        onChange={handleInputChange}
                        error={!!formErrors.firstName}
                        helperText={formErrors.firstName}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#fff",
                          boxShadow: 1,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Last Name"
                        name="lastName"
                        fullWidth
                        margin="normal"
                        required
                        value={formData.lastName}
                        onChange={handleInputChange}
                        error={!!formErrors.lastName}
                        helperText={formErrors.lastName}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#fff",
                          boxShadow: 1,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Email"
                        name="email"
                        type="email"
                        fullWidth
                        margin="normal"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        error={!!formErrors.email}
                        helperText={formErrors.email}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#fff",
                          boxShadow: 1,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Subject"
                        name="subject"
                        fullWidth
                        margin="normal"
                        value={formData.subject}
                        onChange={handleInputChange}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#fff",
                          boxShadow: 1,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Message"
                        name="message"
                        multiline
                        rows={4}
                        fullWidth
                        margin="normal"
                        required
                        value={formData.message}
                        onChange={handleInputChange}
                        error={!!formErrors.message}
                        helperText={formErrors.message}
                        sx={{
                          borderRadius: 2,
                          backgroundColor: "#fff",
                          boxShadow: 1,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      marginTop: 2,
                      padding: 1.5,
                      borderRadius: 2,
                      backgroundColor: "orangeRed",
                      "&:hover": { backgroundColor: "#ff6347" },
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    Submit
                  </Button>
                </form>
              </CardContent>
            </Card>
          </Grid>

          {/* Contact Information Section */}
          <Grid item xs={12} md={6}>
            <Card sx={{ boxShadow: 4, borderRadius: 2 }}>
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{ marginBottom: 2, color: "#333" }}
                >
                  Contact Information
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <LocationOn sx={{ color: "orangeRed", marginRight: 1 }} />
                  <Typography variant="body1" color="textSecondary">
                    Royal square apartment, beside Gowtham model school, kphb
                    5th phase, Hyderabad, Telanagana, India
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Phone sx={{ color: "orangeRed", marginRight: 1 }} />
                  <Typography variant="body1" color="textSecondary">
                    9133959551
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Email sx={{ color: "orangeRed", marginRight: 1 }} />
                  <Typography variant="body1" color="textSecondary">
                    Support@goclutch.in
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  sx={{ marginTop: 3, color: "#333", textAlign: "center" }}
                >
                  Follow Us
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    justifyContent: "center",
                    gap: 3,
                  }}
                >
                  <Link
                    href="https://www.facebook.com/goclutch.in/"
                    target="_blank"
                  >
                    <IconButton
                      sx={{ color: "#000", "&:hover": { color: "orangered" } }}
                    >
                      <FaFacebookF size={22} />
                    </IconButton>
                  </Link>
                  <Link
                    href="https://www.instagram.com/goclutch.in/"
                    target="_blank"
                  >
                    <IconButton
                      sx={{ color: "#000", "&:hover": { color: "orangered" } }}
                    >
                      <FaInstagram size={22} />
                    </IconButton>
                  </Link>
                  <Link
                    href="https://www.linkedin.com/company/goclutch-in/?viewAsMember=true"
                    target="_blank"
                  >
                    <IconButton
                      sx={{ color: "#000", "&:hover": { color: "orangered" } }}
                    >
                      <FaLinkedin size={22} />
                    </IconButton>
                  </Link>
                  <Link href="https://x.com/GoClutch1" target="_blank">
                    <IconButton
                      sx={{ color: "#000", "&:hover": { color: "orangered" } }}
                    >
                      <FaTwitter size={22} />
                    </IconButton>
                  </Link>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ContactUs;
